import * as React from 'react';
import { useEffect } from 'react';
import { Button, FormItem, Modal, Checkbox, Divider, TextArea } from '@iba-team/portal-react-components/dist';
import { DaysAvailableNamespace } from '../types';
import { useTranslation } from 'react-i18next';
import { InputNumber } from '../../../../utils_components/InputNumber';
import { useSetState } from 'react-use';
import './AllowanceModalStyles.scss';
import { observer } from 'mobx-react';
import { DaysAvailableStore } from '../../../../store/DaysAvailable';

export const AllowanceModal = observer((props: DaysAvailableNamespace.AllowanceModalCallProps) => {
  const {t} = useTranslation();
  const {updateUserBalance, fetchProfileRemainingDays} = DaysAvailableStore;
  const [data, setData] = useSetState<DaysAvailableNamespace.UpdateAllowanceBaseFields>({isAllowancePermanent: false, comment: '', newValue: 0});

  useEffect(() => {
    setData({newValue: props.allowance});
  }, [props.allowance]);

  const disabledCondition = (data.newValue === undefined || data.newValue < 0) || data.newValue === props.allowance  || !data.comment.length;
  const onSubmit = () => {
    updateUserBalance({...data,
      employeeId: props.userId,
      valueType: DaysAvailableNamespace.BalanceType.ALLOWANCE,
      oldValue: props.allowance
    }).then(() => {
      setTimeout(() => {
        props.onClose();
        fetchProfileRemainingDays({userId: props.userId});
      }, 200);
    });
  };

  const footer = [
    <Button theme={{color: 'grey', variant: 'neutral'}} onClick={props.onClose}>{t('buttons.cancel')}</Button>,
    <Button theme={{color: 'green', variant: 'primary'}} onClick={onSubmit} disabled={disabledCondition}>{t('buttons.save')}</Button>,
  ];
  return (
    <Modal visible={true}
      titleText={t('availableDays.modals.allowance.title')}
      footer={footer}
      onClose={props.onClose}>
      <div className={'allowanceModal-container'}>
        <p className={'allowanceModal-container__description'}>
          {t('availableDays.modals.allowance.description')}
        </p>
        <FormItem label={t('availableDays.modals.allowance.title')} isRequired>
          <InputNumber
            min={0}
            placeholder={'0'}
            onChange={(val) => {
              setData({newValue: Math.abs(val)});
            }}
            value={data.newValue}/>
        </FormItem>
        <Checkbox
          setChecked={(v) =>  setData({isAllowancePermanent: v})} label={t('availableDays.modals.allowance.checkboxLabel')}
          checked={data.isAllowancePermanent}/>
        <p className={'allowanceModal-container__checkboxDescription'}>
          {t('availableDays.modals.allowance.checkboxLabelDescription')}
        </p>
        <Divider className={'content-divider'}/>
        <FormItem isRequired label={t('availableDays.modals.allowance.reasonLabel')}>
          <TextArea onChange={(e) => setData({comment: e.target.value})} placeholder={t('placeholder.reasonPlaceholder')}/>
          <p className={'allowanceModal-container__reasonText'}>
            {t('availableDays.modals.reasonDescription')}
          </p>
        </FormItem>
      </div>
    </Modal>
  );
});